import React, { useEffect, useState } from "react";
import { Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import { getTour } from "../api";

const antIcon = <LoadingOutlined style={{ fontSize: 50 }} spin />;

export const validateTour = Component => props => {
    const [isTourValid, setIsTourValid] = useState(false);
    const [tourData, setTourData] = useState(null);

    useEffect(() => {
        (async function getTourDetails() {
            let tourId = props.routeParams.match.params.tourId;
            const tourDetail = await getTour(tourId);
            if (tourDetail.err) {
                props.routeParams.history.push("/error");
            } else {
                setTourData(tourDetail);
                setIsTourValid(true);
            }
        })();
    }, [props.routeParams.history, props.routeParams.match.params.tourId]);

    return isTourValid ? (
        <Component {...props} data={tourData} />
    ) : (
        <div
            style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "80vh",
            }}
        >
            <div style={{ display: "flex", flexDirection: "column" }}>
                <div className="icons">
                    <Spin indicator={antIcon} />
                </div>
                <h2 style={{ letterSpacing: "2.5px", marginTop: "1rem", color: "grey" }}>Checking Tour validity...</h2>
            </div>
        </div>
    );
};
